import { render, staticRenderFns } from "./MyDemand.vue?vue&type=template&id=7a38144c&scoped=true&"
import script from "./MyDemand.vue?vue&type=script&lang=js&"
export * from "./MyDemand.vue?vue&type=script&lang=js&"
import style0 from "./MyDemand.vue?vue&type=style&index=0&id=7a38144c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38144c",
  null
  
)

export default component.exports